import arrowDownIcon from '@library/assets/images/icons/arrow-down.svg';
import { classNames } from '@library/utils';

interface TagSuffixProps {
  additionalSelected: number;
}

const TagSuffix = ({ additionalSelected }: TagSuffixProps) => {
  return (
    <div
      className={classNames(
        'bg-soFresh-140 mx-2 grid h-6 w-fit items-center gap-1 rounded-lg px-2'
      )}
    >
      <span className="text-soClean-100 text-sm">
        {`+${additionalSelected}`}
      </span>
    </div>
  );
};

interface ArrowSuffixProps {
  open: boolean;
  iconOnly?: boolean;
}

const ArrowSuffix = ({ open, iconOnly = false }: ArrowSuffixProps) => {
  return (
    <span
      className={classNames(
        'pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2',
        iconOnly ? 'hidden !p-0 !pt-[.09rem] group-hover/ms:block' : '',
        iconOnly && open ? '!block' : ''
      )}
    >
      <img
        className={classNames(open ? 'rotate-180' : '')}
        src={arrowDownIcon}
        alt="Chevron Down icon"
      />
    </span>
  );
};

export interface MultiSelectButtonProps {
  allSelected: boolean;
  allSelectedDisplayValue: string;
  firstOptionName: string;
  iconOnly?: boolean;
  numberSelected: number;
  open: boolean;
  label: string;
  size: 'extrasmall' | 'small' | 'medium';
  showTags: boolean;
}

export const MultiSelectButton = ({
  allSelected,
  allSelectedDisplayValue,
  firstOptionName,
  iconOnly = false,
  numberSelected,
  open,
  label,
  size,
  showTags
}: MultiSelectButtonProps) => {
  const smallSize = size === 'extrasmall' || 'small';

  const showPartialSelectedDisplayValue = showTags && numberSelected > 0;

  const partialSelectedDisplayValue = showPartialSelectedDisplayValue
    ? firstOptionName
    : `${label} ${numberSelected ?? ''}`;

  const displayValue =
    !numberSelected || (allSelected && numberSelected > 1)
      ? allSelectedDisplayValue
      : partialSelectedDisplayValue;

  const showTagSuffix = showTags && !allSelected && numberSelected > 1;

  return (
    <>
      <span
        className={classNames(
          'flex items-center whitespace-nowrap pl-3',
          showTagSuffix ? '' : 'pr-8',
          smallSize ? 'text-xs' : 'text-base',
          !showTags && !iconOnly ? 'pr-10' : '',
          iconOnly
            ? `!pl-1 ${open ? '!min-w-[39px] !pr-5' : '!pr-1'} group-hover/ms:!pr-5`
            : ''
        )}
      >
        {displayValue}
      </span>
      {showTagSuffix ? (
        <TagSuffix additionalSelected={numberSelected - 1} />
      ) : (
        <ArrowSuffix open={open} iconOnly={iconOnly} />
      )}
    </>
  );
};
